import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { format } from "date-fns";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EMPTY_BOOKING_FORM = {
  name: "", email: "", phone: "", bookingType: "appointment",
  service: "bracelets", date: null, time: "", partySize: "", message: "",
};

function validateBookingForm(form) {
  if (!form.date || !form.time) {
    return "Please select a preferred date and time slot.";
  }
  return null;
}

export function useBookingForm(prefill) {
  const [form, setForm] = useState(EMPTY_BOOKING_FORM);
  const [submitting, setSubmitting] = useState(false);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  useEffect(() => {
    if (!prefill || !prefill.token) return;
    setForm((f) => ({
      ...f,
      bookingType: prefill.bookingType || f.bookingType,
      service: prefill.service || f.service,
    }));
  }, [prefill, setForm]);

  const submit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    const validationError = validateBookingForm(form);
    if (validationError) {
      toast.error("Almost there", { description: validationError });
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/bookings`, {
        name: form.name,
        email: form.email,
        phone: form.phone || null,
        booking_type: form.bookingType,
        service: form.service,
        preferred_date: format(form.date, "EEEE, MMMM d, yyyy"),
        preferred_time: form.time,
        party_size: form.bookingType === "party" && form.partySize ? Number(form.partySize) : null,
        message: form.message || null,
      });
      toast.success("Enquiry sent", {
        description: "Thank you — we'll reply from booking@faithfullylinked.app within 24 hours.",
      });
      setForm({ ...EMPTY_BOOKING_FORM, bookingType: form.bookingType, service: form.service });
    } catch (err) {
      toast.error("Something went wrong", {
        description: "Please try again, or email us directly at booking@faithfullylinked.app.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return { form, set, submitting, calendarOpen, setCalendarOpen, submit };
}
